export const buildCompetitorImportInitialValues = ({ url, type } = {}) => {
  if (type === "video") {
    return {
      referenceAdUrl: url,
      referenceAdMediaType: "video",
      mediaType: "video",
      videoType: "other",
      expandAdvancedConfigurationAccordion: true,
    };
  }

  return {
    referenceAdUrl: url,
    mediaType: "image",
    expandAdvancedConfigurationAccordion: true,
  };
};
